module.exports = __webpack_public_path__ + "info.53fb9ae90b06dbdb1950f548accf9ad7.svg";


//////////////////
// WEBPACK FOOTER
// ./frontend/images/info.svg
// module id = ./frontend/images/info.svg
// module chunks = 1